export const comments_4180333 = {"data":{"data":[],"links":{}}}